import Sections from './sections';

export default Sections;